import cn from 'classnames';
import {FC, useEffect, useRef, useState} from 'react';
import {useOutsideClick} from '../../hooks';
import './selector.sass';

export type SelectItem = {
  value: string | number;
  icon?: string;
  renderValue?: string;
};

type Props = {
  className?: string;
  selected?: SelectItem;
  onSelect: (item: SelectItem) => void;
  list: SelectItem[];
  disabled?: boolean;
};

export const Selector: FC<Props> = ({selected, onSelect, list, disabled, className}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [width, setWidth] = useState<number>();

  const togglePopup = () => {
    if (disabled) return;

    setIsOpen(state => !state);
  };

  const onClick = (selected: SelectItem) => {
    onSelect(selected);
    setIsOpen(false);
  };

  useOutsideClick(ref, () => setIsOpen(false));

  useEffect(() => {
    if (!ref.current) return;
  }, [ref]);

  return (
    <button className={cn('selector', className)}>
      <div className={cn('selector__item', {_open: isOpen})} onClick={togglePopup}>
        {selected?.icon && <img className="selector__item-icon" src={selected?.icon} alt={selected?.renderValue} />}
        {selected?.renderValue || selected?.value}
      </div>
      <div ref={ref} className={cn('selector__popup', {_open: isOpen})}>
        {list.map((item, i) => (
          <div key={'selector-item' + i} className="selector__item" onClick={() => onClick(item)}>
            {item.icon && <img className="selector__item-icon" src={item.icon} alt={item.renderValue} />}
            {item.renderValue || item.value}
          </div>
        ))}
      </div>
    </button>
  );
};
